import { useMutation, useQuery } from "urql";

const GET_FLOW = `
query GET_FLOW($companyId: String!, $currency: String!, $view: String, $showProjections: Boolean) {
	getFlow(companyId: $companyId, currency: $currency, view: $view, showProjections: $showProjections) {
    id
	  companyId
    name
    primaryView
    pastMonthsView
    futureMonthsView
    periods {
      start
      end
      isPast
      view
    }
    report { 
      INCOME {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isHidden
          values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
      }
      EXPENSE {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isHidden
          values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
      }
      RESUME {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        fields {
          label
          cashflowAreaId
          isIncome
          values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
        }
				values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
      }
      TOTAL {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        fields {
          label
          cashflowAreaId
          isIncome
          values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          documents
        }
      }
    }
	}
}
`;

const GET_FLOW_STRUCTURE = `
query GET_FLOW_STRUCTURE($companyId: String!) {
	getFlowStructure(companyId: $companyId) {
  id
	companyId
    name
    report { 
      INCOME {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isDefault
        isVisible
        isHidden
        fields {
          label
          cashflowAreaId
          isIncome
          isDefault
          isVisible
          isHidden
        }
      }
      EXPENSE {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isDefault
        isVisible
        isHidden
        fields {
          label
          cashflowAreaId
          isIncome
          isDefault
          isVisible
          isHidden
        }
      }
    }
	}
}
`;

const CREATE_FLOW_FIELD = `
mutation CREATE_FLOW_FIELD(
  $companyId: String!,
  $id: String!,
  $fieldLabel: String!,
  $cashflowCategoryId: String!,
) {
	createFlowField(
    companyId: $companyId,
    id: $id,
    fieldLabel: $fieldLabel,
    cashflowCategoryId: $cashflowCategoryId,
  ) {
    status
    message
    data
	}
}
`;

const CREATE_FLOW_CATEGORY = `
mutation CREATE_FLOW_CATEGORY(
  $companyId: String!,
  $id: String!,
  $label: String!,
  $isIncome: Boolean!,
  $newFieldLabel: String,
  $importedFields: [String!]!,

) {
	createFlowCategory(
    companyId: $companyId,
    id: $id,
    label: $label,
    isIncome: $isIncome,
    newFieldLabel: $newFieldLabel,
    importedFields: $importedFields,
  ) {
    status
    message
    data
	}
}
`;



const EDIT_FLOW_CATEGORY = `
mutation EDIT_FLOW_CATEGORY(
  $companyId: String!,
  $id: String!,
  $cashflowCategoryId: String!,
  $newLabel: String,
  $importedFields: [String!]!,
) {
	editFlowCategory(
    companyId: $companyId,
    id: $id,
    cashflowCategoryId: $cashflowCategoryId,
    newLabel: $newLabel,
    importedFields: $importedFields,
  ) {
    status
    message
    data
	}
}
`;

const UPDATE_CATEGORY_ORDER = `
mutation UPDATE_CATEGORY_ORDER(
  $companyId: String!,
  $id: String!,
  $input: UpdateCategoryOrderInput!,
) {
  updateCategoryOrder(
    companyId: $companyId,
    id: $id,
    input: $input
  ) {
    status
    message
    data
  }
}
`;

export const UpdateFlowCategoryOrder = () => {
  const [result, executeMutation] = useMutation(UPDATE_CATEGORY_ORDER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}

const UPDATE_AREA_ORDER = `
mutation UPDATE_AREA_ORDER(
  $companyId: String!,
  $id: String!,
  $input: UpdateAreaOrderInput!,
) {
  updateAreaOrder(
    companyId: $companyId,
    id: $id,
    input: $input
  ) {
    status
    message
    data
  }
}
`;

export const UpdateFlowAreaOrder = () => {
  const [result, executeMutation] = useMutation(UPDATE_AREA_ORDER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}

const DELETE_FLOW_CATEGORY = `
mutation DELETE_FLOW_CATEGORY(
  $companyId: String!,
  $id: String!,
  $cashflowCategoryId: String!,
) {
	deleteFlowCategory(
    companyId: $companyId,
    id: $id,
    cashflowCategoryId: $cashflowCategoryId,
  ) {
    status
    message
    data
	}
}
`;

const EDIT_FLOW_FIELD = `
mutation EDIT_FLOW_FIELD(
  $companyId: String!,
  $id: String!,
  $newLabel: String,
  $cashflowAreaId: String!,
  $newCashflowCategoryId: String,
  $isHidden: Boolean
) {
	editFlowField(
    companyId: $companyId,
    id: $id,
    newLabel: $newLabel,
    cashflowAreaId: $cashflowAreaId,
    newCashflowCategoryId: $newCashflowCategoryId,
    isHidden: $isHidden
  ) {
    status
    message
    data
	}
}
`;

const FLOW_FIELD_DETAIL = `
query FLOW_FIELD_DETAIL(
  $companyId: String!,
  $pointIds: [String!]!,
) {
	getFlowAreaDetail(
    companyId: $companyId,
    pointIds: $pointIds,
  ) {
    totalAmount
    totalLength
    lateAmount
    lateLength
    settledAmount
    settledLength
    documents {
      id
      companyId
      name
      isLate
      dueDate
      documentDate
      documentType
      currencyType
      description
      amount
      cashflowAreaId
      recurringId
      paymentDate
      meta {
        ... on TaxDocumentMeta {
          factoring {
            cedido
          }
          isPaid
          isReceived
          issuerId
          issuerName
          receiverId
          receiverName
          documentId
          downloadURL
          download {
            pdf {
              url
            }
            xml {
              url
            }
            html {
              url  
            }
          }
          remaining
          originalAmount
          documentCode
          isReceived
          documentId
          summary
          matchs {
            inMatch {
              id
              settleId
              origin
              type
              amount
              selected
              obligationType
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
            outMatch {
              id
              amount
              selected
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
          }
        }
      }

      meta {
        ... on ObligationMeta {
          isPaid
          isReceived
          issuerName
          issuerId
          receiverId
          receiverName
          documentId
          number
          typeLabel
          remaining
          originalAmount
          amount
          type
          isReceived
          tipo
          detail {
            description
            item
            quantity
            unit_price
            total_price
            name
          }
          matchs {
            inMatch {
              id
              settleId
              origin
              type
              amount
              selected
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
            outMatch {
              id
              amount
              selected
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
          }
        }
      }

      meta {
        ... on CreditsMeta {
          installments
          interest
          stock
          totalPayments
          paymentNumber
          isPaid
          identificator
          period
          flexiblePeriod
          remaining
          matchs {
            inMatch {
              id
              settleId
              origin
              type
              amount
              selected
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
            outMatch {
              id
              amount
              selected
              userRelated {
                userId
                firstName
                lastName
                date
              }
            }
          }
        }
      }
    }
	}
}
`;

export const GetFlow = ({ companyId, currency, view, showProjections }) => {
  const [result, reexecuteFlow] = useQuery({
    query: GET_FLOW,
    variables: { companyId, currency, view, showProjections },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteFlow };
}

export const GetFieldDetail = ({ companyId, pointIds }) => {
  const [result, reexecuteFlow] = useQuery({
    query: FLOW_FIELD_DETAIL,
    variables: { companyId, pointIds },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteFlow };
}

export const GetFlowStructure = ({ companyId }) => {
  const [result, reexecuteFlow] = useQuery({
    query: GET_FLOW_STRUCTURE,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteFlow };
}

export const CreateFlowField = () => {
  const [result, executeMutation] = useMutation(CREATE_FLOW_FIELD);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}

export const EditFlowField = () => {
  const [result, executeMutation] = useMutation(EDIT_FLOW_FIELD);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}

export const CreateFlowCategory = () => {
  const [result, executeMutation] = useMutation(CREATE_FLOW_CATEGORY);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}

export const EditFlowCategory = () => {
  const [result, executeMutation] = useMutation(EDIT_FLOW_CATEGORY);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}



export const DeleteFlowCategory = () => {
  const [result, executeMutation] = useMutation(DELETE_FLOW_CATEGORY);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}



const GET_EXCEL_CASHFLOW = `mutation GET_EXCEL_CASHFLOW($companyId: String!, $currency: String!, $view: String, $showProjections: Boolean) {
  CashFlowAsExcel(companyId: $companyId , currency : $currency, view : $view, showProjections : $showProjections)
}`

export const GetExcelCashFlow = () => {
  const [result, executeMutation] = useMutation(GET_EXCEL_CASHFLOW);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
}
